import {
  ACADEMY_PATH,
  CONTRIBUTE_PATH,
  SOLUTION_EMPCO_PATH,
  SOLUTION_SBTI_PATH,
  SOLUTION_SCOPE3_PATH,
} from "../../shared/routing/paths/hub";
import { commonLabels } from "../../shared/ui/labels/common-labels";
import { solutionLabels } from "./pages/solutions/labels";
import {
  HubAcademyPage,
  HubContributionPage,
  HubRoute,
  HubSolutionEmpcoPage,
  HubSolutionSbtiPage,
  HubSolutionScope3Page,
} from "./route-elements";

/**
 * The Homepage is not mounted here. Its only path is `/`, owned by `HomeEntryRoute`, which
 * renders it through `HubShell` so the post-login landing keeps its own decisions (deep-link
 * restore, the internal-staff branch) rather than becoming a plain route.
 *
 * The pathless layout route's "Home" crumb resolves to `/`.
 */
export const HubRoutes = {
  element: <HubRoute />,
  handle: { crumb: commonLabels.navigation.home },
  children: [
    { path: ACADEMY_PATH, handle: { crumb: "Academy" }, element: <HubAcademyPage /> },
    { path: CONTRIBUTE_PATH, element: <HubContributionPage /> },
    {
      path: SOLUTION_SBTI_PATH,
      handle: { crumb: solutionLabels.sbti.pageTitle },
      element: <HubSolutionSbtiPage />,
    },
    {
      path: SOLUTION_EMPCO_PATH,
      handle: { crumb: solutionLabels.empco.pageTitle },
      element: <HubSolutionEmpcoPage />,
    },
    {
      path: SOLUTION_SCOPE3_PATH,
      handle: { crumb: solutionLabels.scope3.pageTitle },
      element: <HubSolutionScope3Page />,
    },
  ],
};
